export default __webpack_public_path__ + "poi-800-ccbd74aacdeb23455d566fff157cc3ea.webp";